/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { WeatherThermometerIcon16Light } from './WeatherThermometerIcon16Light';
import { WeatherThermometerIcon16Regular } from './WeatherThermometerIcon16Regular';
import { WeatherThermometerIcon16Solid } from './WeatherThermometerIcon16Solid';
import { WeatherThermometerIcon20Light } from './WeatherThermometerIcon20Light';
import { WeatherThermometerIcon20Regular } from './WeatherThermometerIcon20Regular';
import { WeatherThermometerIcon20Solid } from './WeatherThermometerIcon20Solid';
import { WeatherThermometerIcon24Regular } from './WeatherThermometerIcon24Regular';
import { WeatherThermometerIcon24Solid } from './WeatherThermometerIcon24Solid';
import { WeatherThermometerIcon32Regular } from './WeatherThermometerIcon32Regular';
import { WeatherThermometerIcon64Regular } from './WeatherThermometerIcon64Regular';
var sizes = {
    16: {
        light: WeatherThermometerIcon16Light,
        regular: WeatherThermometerIcon16Regular,
        solid: WeatherThermometerIcon16Solid,
    },
    20: {
        light: WeatherThermometerIcon20Light,
        regular: WeatherThermometerIcon20Regular,
        solid: WeatherThermometerIcon20Solid,
    },
    24: {
        regular: WeatherThermometerIcon24Regular,
        solid: WeatherThermometerIcon24Solid,
    },
    32: {
        regular: WeatherThermometerIcon32Regular,
    },
    64: {
        regular: WeatherThermometerIcon64Regular,
    },
};
export var WeatherThermometerIcon = forwardRef('WeatherThermometerIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
